module.exports = __webpack_public_path__ + "static/wiz5-0a6f00c0800cd2bfbd42ea4cd2f1fe0d.jpg";